{
  "name": "fx-terminal",
  "version": "3.283.251",
  "description": "Trading terminal of 50x.com exchange",
  "targets": {
    "default": {
      "context": "browser",
      "distDir": "./dist/media/js/",
      "outputFormat": "global",
      "source": "./src/index.ts",
      "isLibrary": false,
      "includeNodeModules": true,
      "scopeHoist": false
    }
  },
  "typesVersions": {
    "<3.8": {
      "*": [
        "ts3.8/*"
      ]
    }
  },
  "scripts": {
    "buildtest": "tsc --project tsconfig.test.json",
    "test_": "wtr",
    "test": "wtr --config web-test-runner.config.mjs --watch",
    "styles": "stylus -w ./src/css/styles.styl -o ./dist/media/css/styles.css --include-css",
    "builder": "node builder/build.js",
    "tsc": "tsc -w",
    "storybook": "start-storybook -p 6007 -s ./src/stories/assets",
    "build-storybook": "build-storybook",
    "check": "tsc --noEmit -w",
    "dev": "parcel watch --no-hmr",
    "build": "parcel build"
  },
  "keywords": [],
  "author": "kaifaty",
  "license": "ISC",
  "dependencies": {
    "@swc/helpers": "^0.2.14",
    "chart.js": "^3.6.2",
    "firebase": "^9.6.5",
    "helpful-decorators": "^2.1.0",
    "idb": "^6.1.2",
    "kailib": "^1.0.42",
    "lit": "^2.0.2",
    "nvm": "^0.0.4",
    "simple-translations": "^1.0.35",
    "tslib": "^2.3.1",
    "ui-lit": "0.0.283"
  },
  "devDependencies": {
    "@babel/cli": "^7.14.8",
    "@babel/core": "^7.15.0",
    "@babel/preset-env": "^7.15.0",
    "@babel/preset-typescript": "^7.16.0",
    "@esm-bundle/chai": "^4.3.4",
    "@open-wc/testing": "^2.5.33",
    "@parcel/transformer-typescript-tsc": "^2.8.3",
    "@parcel/transformer-typescript-types": "^2.0.1",
    "@storybook/addon-actions": "^6.4.19",
    "@storybook/addon-essentials": "^6.4.19",
    "@storybook/addon-links": "^6.4.19",
    "@storybook/web-components": "^6.4.19",
    "@types/mocha": "^8.2.2",
    "@types/node": "^14.14.41",
    "@web/dev-server": "^0.1.17",
    "@web/dev-server-esbuild": "^0.2.12",
    "@web/rollup-plugin-html": "^1.10.0",
    "@web/test-runner": "^0.13.5",
    "@web/test-runner-playwright": "^0.8.6",
    "app-root-path": "^3.0.0",
    "babel-loader": "^8.2.3",
    "babel-plugin-import": "^1.13.3",
    "babel-plugin-template-html-minifier": "^4.1.0",
    "babel-preset-env": "^1.7.0",
    "child_process": "^1.0.2",
    "mocha": "^8.4.0",
    "parcel": "^2.8.3",
    "terser": "^5.7.2",
    "typescript": "^4.2.3"
  }
}